<template>
  <div class="primary-theme dark-theme c-fluid" id="work">
    <div class="row">
      <div class="col-sm-12 col-lg-8 px-0 row">
        <div class="col-3 title-line yellow my-auto"></div>
        <div class="col-4 title-text my-auto text-center">W H A T &nbsp; W E &nbsp; D O</div>
        <div class="col-5 title-line yellow my-auto"></div>
      </div>
    </div>
    <div class="section-content">
      <h1 class="quote">a & b initiative seeks to be awesome and beautiful through various channels</h1>

      <div class="row mx-auto">
        <div
          class="col-xs-12 col-sm-12 col-md-6 col-lg-4 mb-4"
          v-for="(val, index) in list"
          :key="index"
          :class="{'d-ac-none': index > 1 && showLess}"
        >
          <div class="light-theme ac-content">
            <img :src="val.img" class="img" />
            <h3>{{val.title}}</h3>
            <p class="text-justify">
              {{val.subText}}
              <i v-if="val.hasQuote">"{{val.quote}}".</i>
            </p>

            <button
              type="button"
              class="ac-btn py-3 px-4"
              data-toggle="modal"
              :data-target="'#modal' + index"
              @click="toggleModal('#modal' + index)"
            >R E A D &nbsp; M O R E</button>
          </div>
        </div>
      </div>
      <span
        class="float-right p-3 d-sh-none pointer"
        @click="showLess = !showLess"
      >{{showLess ? '+ M O R E' : '- L E S S'}}</span>
    </div>

    <div
      class="modal"
      tabindex="-1"
      role="dialog"
      v-for="(val, index) in list"
      :key="index"
      :id="'modal' + index"
    >
      <div class="modal-dialog light-theme" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{val.title}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-justify px-4 pt-0">
            <img :src="val.img" class="img mb-5" />

            <p v-if="val.body.goal">
              <span class="fw-6 title">The goal:</span>
              {{val.body.goal}}
            </p>
            <p v-if="val.body.challenge">
              <span class="fw-6 title">The challenge:</span>
              {{val.body.challenge}}
            </p>
            <ul class="mb-2" v-if="val.body.challengeList">
              <li v-for="(l, index) in val.body.challengeList" :key="index">{{l}}</li>
            </ul>

            <p v-if="val.body.opportunity">
              <span class="fw-6 title">The opportunity:</span>
              {{val.body.opportunity}}
            </p>
            <p v-if="val.body.focus">
              <span class="fw-6 title">The focus:</span>
              {{val.body.focus}}
            </p>
            <p v-if="val.body.strategy">
              <span class="fw-6 title">The strategy:</span>
              {{val.body.strategy}}
            </p>
            <p v-if="val.body.otherStrategy">{{val.body.otherStrategy}}</p>
            <ul class="mb-2" v-if="val.body.strategyList">
              <li v-for="(l, index) in val.body.strategyList" :key="index">{{l}}</li>
            </ul>

            <p v-if="val.body.other">{{val.body.other}}</p>
            <p v-if="val.body.other2">{{val.body.other2}}</p>

            <p v-if="val.body.isContact">
              To find out more, please
              <span
                class="pointer contact strong"
                @click="scrollToContact('#modal' + index)"
              >contact us</span>
            </p>

            <ul class="mb-2" v-if="val.body.otherList">
              <li v-for="(l, index) in val.body.otherList" :key="index">{{l}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./../compiled-icons/arrow";
import data from "./../data/data";
export default {
  name: "Activity",
  data() {
    return {
      list: data.activities,
      showLess: true
    };
  },
  methods: {
    toggleModal(modalId) {
      $("#myModal")
        .on("show", function() {
          $("body").addClass("modal-open");
        })
        .on("hidden", function() {
          $("body").removeClass("modal-open");
        });
    },
    scrollToContact(modalId) {
      $(modalId).modal("hide");
      $("html, body").animate(
        {
          scrollTop: $("#contact").offset().top
        },
        0
      );
    }
  }
};
</script>

<style scoped>
.img {
  width: 100%;
}
.icon {
  width: 20px;
}
@media screen and (max-width: 500px) {
  .ac-content {
    height: 420px;
  }
  .ac-content h3 {
    margin: 1rem !important;
    font-size: 1.2rem;
  }
  .ac-content p {
    margin: 1rem !important;
    font-size: 0.8rem;
  }
}

@media screen and (min-width: 501px) {
  .ac-content {
    height: 520px;
  }
  .ac-content h3,
  .ac-content p {
    margin: 1.5rem !important;
  }
  .ac-content p {
    margin: 1.5rem !important;
  }
}

@media screen and (max-width: 767px) {
  .d-ac-none {
    display: none;
  }
}

@media screen and (min-width: 766px) {
  .d-sh-none {
    display: none;
  }
}

.ac-btn {
  bottom: 0;
  right: 15px;
  position: absolute;
}
.title {
  font-family: sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/Activity.vue